var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM34.8571 20.5714C34.8571 18.9935 33.578 17.7143 32 17.7143C30.422 17.7143 29.1429 18.9935 29.1429 20.5714V32C29.1429 32.6684 29.3772 33.3156 29.8051 33.8291L41.2337 47.5434C42.2438 48.7556 44.0454 48.9194 45.2577 47.9092C46.4699 46.899 46.6337 45.0974 45.6235 43.8852L34.8571 30.9656V20.5714Z",
    fill: "#FFA114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.65d6cace44bf30b51ef655350c9b2d13.svg";
export { ForwardRef as ReactComponent };